<!--
 * @Description:弹窗表单组件
 * @Author: windy
 * @Date: 2024-08-29 16:52:23
-->
<template>
	<tq-dialog
		:model-value="props.dialogVisible"
		:title="props.title"
		:before-close="handleClose"
		hiddenCancel
		hiddenConfirm
		class="tq_dialog_form"
		style="width: 40%;"
  	>
		<tq-form
			:button-config="buttonConfig"
			:form-key-with-values="formKeyWithValues"
			label-width="90px"
			:form-items="formItems"
			@formSubmit="formSubmit"
			@formClose="formClose"
		>
		</tq-form>

		<!-- 弹窗底部插槽 -->
		<template #footer>
			<slot name="footer"></slot>
		</template>
		<!-- 弹窗头部插槽 -->
		<template #header>
			<slot name="header"></slot>
		</template>
		<!-- 弹窗默认插槽 -->
		<template>
			<slot></slot>
		</template>
	</tq-dialog>

</template>

<script setup lang="ts">
defineOptions({
  name: "TqDialogForm",
});

// 表单按钮配置格式
interface buttonConfigType {
	leftButtonShow: boolean,
	leftButtonText: string,
	rightButtonShow: boolean,
	rightButtonText: string
}

const props = defineProps({
	dialogVisible: { // 弹窗是否显示
		type: Boolean,
		default: false
	},
	title: { // 弹窗标题
		type: String,
		default: ''
	},
	handleClose: { // 关闭弹窗
		type: Function,
		default: () => {}
	},
	buttonConfig: { // 表单按钮配置
		type: Object,
		default: () => {
			return <buttonConfigType>{}
		}
	},
	formItems: { // 表单项配置，类型待补充
		type: Array,
		default: () => {
			return []
		}
	},
	formKeyWithValues: { // 表单value动态数据，类型待补充
		type: Object,
		default: () => {
			return {}
		}
	}
})


const emit = defineEmits(['formSubmit', 'formClose'])
// 表单提交
const formSubmit = (valid: boolean,data: { [key: string]: unknown }) => {
	emit("formSubmit", valid, data)
}
// 表单关闭
const formClose = (data: { [key: string]: unknown }) => {
	emit("formClose", data)
}
</script>

<style scoped lang="stylus">
.tq_dialog_form
	.el-dialog__body
		.tq-form-content
			:deep(.el-form)
				.formcontrol_form-title-border
					display none
				.formcontrol_form-item_border
					border none
					padding-top 0px
					margin-bottom 0px
</style>